import { render, staticRenderFns } from "./ModifyAxxessVumatelFtthPackageModal.vue?vue&type=template&id=3395f6f8&scoped=true&"
import script from "./ModifyAxxessVumatelFtthPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyAxxessVumatelFtthPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3395f6f8",
  null
  
)

export default component.exports